<div class="ss-widget" [ngSwitch]="kind()">

  <!-- Input Box -->
  <div *ngSwitchCase="'input-box'" class="ss-widget-field">
    <label *ngIf="label()" class="ss-widget-label">{{ label() }}</label>
    <input
      type="text"
      class="ss-widget-input"
      [placeholder]="placeholder() || 'Enter a value'"
      [ngModel]="inputValue"
      (ngModelChange)="onInputValueChange($event)"
    />
  </div>

  <!-- Slider -->
  <div *ngSwitchCase="'slider'" class="ss-widget-field">
    <label *ngIf="label()" class="ss-widget-label">{{ label() }}</label>
    <mat-slider class="ss-widget-slider" [min]="min()" [max]="max()" [step]="step()" discrete>
      <input matSliderThumb [ngModel]="currentSliderValue()" (ngModelChange)="onSliderValueChange($event)" />
    </mat-slider>
    <div class="ss-widget-meta">{{ min() }} – {{ max() }} · step {{ step() }}</div>
  </div>

  <!-- Range Slider -->
  <div *ngSwitchCase="'slider-range'" class="ss-widget-field">
    <label *ngIf="label()" class="ss-widget-label">{{ label() }}</label>
    <mat-slider class="ss-widget-slider" [min]="min()" [max]="max()" [step]="step()" discrete>
      <input matSliderStartThumb [ngModel]="currentRangeStart()" (ngModelChange)="onRangeStartChange($event)" />
      <input matSliderEndThumb [ngModel]="currentRangeEnd()" (ngModelChange)="onRangeEndChange($event)" />
    </mat-slider>
    <div class="ss-widget-meta">{{ currentRangeStart() }} – {{ currentRangeEnd() }}</div>
  </div>

  <!-- Range Bidirectional Slider -->
  <div *ngSwitchCase="'range-bidirectional-slider'" class="ss-widget-field">
    <label *ngIf="label()" class="ss-widget-label">{{ label() }}</label>
    <mat-slider class="ss-widget-slider" [min]="min()" [max]="max()" [step]="step()" discrete>
      <input matSliderThumb [ngModel]="currentSliderValue()" (ngModelChange)="onSliderValueChange($event)" />
    </mat-slider>
    <input
      type="number"
      class="ss-widget-input ss-widget-input-narrow"
      [min]="min()"
      [max]="max()"
      [step]="step()"
      [value]="currentSliderValue()"
      (input)="onSliderValueChange($any($event.target).valueAsNumber)"
    />
  </div>

  <!-- Button -->
  <div *ngSwitchCase="'button'" class="ss-widget-field ss-widget-center">
    <button
      type="button"
      mat-flat-button
      *ngIf="buttonStyle() === 'primary'"
      color="primary"
    >{{ buttonLabel() }}</button>
    <button
      type="button"
      mat-raised-button
      *ngIf="buttonStyle() === 'secondary'"
    >{{ buttonLabel() }}</button>
    <button
      type="button"
      mat-stroked-button
      *ngIf="buttonStyle() === 'stroked'"
    >{{ buttonLabel() }}</button>
  </div>

  <!-- Notes -->
  <div *ngSwitchCase="'notes'" class="ss-widget-notes">
    <div class="ss-widget-label" *ngIf="label()">{{ label() }}</div>
    <ng-container *ngIf="editable(); else notesReadonly">
      <textarea
        class="ss-widget-input ss-widget-notes-input"
        rows="4"
        placeholder="Write your note…"
        [ngModel]="notesText()"
        (ngModelChange)="onNotesInput($event)"
      ></textarea>
    </ng-container>
    <ng-template #notesReadonly>
      <p class="ss-widget-notes-text" *ngIf="notesText(); else emptyNotes">{{ notesText() }}</p>
      <ng-template #emptyNotes>
        <p class="ss-widget-empty">Add note text in the configuration panel.</p>
      </ng-template>
    </ng-template>
  </div>

  <!-- Upload File -->
  <div *ngSwitchCase="'upload-file'" class="ss-widget-upload">
    <label *ngIf="label()" class="ss-widget-label">{{ label() }}</label>
    <div class="ss-widget-dropzone">
      <span class="ss-widget-upload-icon">⬆</span>
      <span>Click to upload {{ multiple() ? 'files' : 'a file' }}</span>
      <span class="ss-widget-meta" *ngIf="accept()">Accepted: {{ accept() }}</span>
      <input
        type="file"
        [accept]="accept()"
        [multiple]="multiple()"
        [disabled]="!editable()"
        (change)="onFilesSelected($event)"
      />
    </div>
    <ul class="ss-widget-file-list" *ngIf="uploadedFileNames().length">
      <li *ngFor="let name of uploadedFileNames(); let i = index" class="ss-widget-file-item">
        <span class="ss-widget-file-name" [title]="name">{{ name }}</span>
        <button
          *ngIf="editable()"
          type="button"
          class="ss-widget-file-remove"
          aria-label="Remove file"
          (click)="removeUploadedFile(i)"
        >✕</button>
      </li>
    </ul>
  </div>

  <!-- Configurable Form -->
  <div *ngSwitchCase="'configurable-form'" class="ss-widget-form">
    <div class="ss-widget-label" *ngIf="label()">{{ label() }}</div>
    <div class="ss-widget-empty" *ngIf="!formFields().length">
      Add form fields in the configuration panel.
    </div>
    <div class="ss-widget-form-grid">
      <div class="ss-widget-form-field" *ngFor="let field of formFields(); trackBy: trackByFieldKey">
        <label>{{ field.label || field.key }}<span *ngIf="field.required" class="ss-req">*</span></label>

        <textarea
          *ngIf="field.type === 'textarea'"
          class="ss-widget-input"
          rows="3"
          [placeholder]="field.placeholder || ''"
          ngModel
          (ngModelChange)="onFormFieldChange(field.key, $event)"
        ></textarea>

        <select *ngIf="field.type === 'select'" class="ss-widget-input" ngModel (ngModelChange)="onFormFieldChange(field.key, $event)">
          <option value="" disabled selected>{{ field.placeholder || 'Select…' }}</option>
          <option *ngFor="let opt of field.options || []" [value]="opt">{{ opt }}</option>
        </select>

        <input
          *ngIf="field.type !== 'textarea' && field.type !== 'select'"
          class="ss-widget-input"
          [type]="field.type"
          [placeholder]="field.placeholder || ''"
          ngModel
          (ngModelChange)="onFormFieldChange(field.key, $event)"
        />
      </div>
    </div>
    <div class="ss-widget-form-actions" *ngIf="formFields().length">
      <button type="button" mat-flat-button color="primary">{{ submitLabel() }}</button>
    </div>
  </div>

  <!-- Editable Table -->
  <div *ngSwitchCase="'editable-table'" class="ss-widget-table">
    <div class="ss-widget-label" *ngIf="label()">{{ label() }}</div>
    <div class="ss-widget-empty" *ngIf="!tableColumns().length">
      Add table columns in the configuration panel.
    </div>
    <div class="ss-widget-table-wrap" *ngIf="tableColumns().length">
      <table>
        <thead>
          <tr>
            <th *ngFor="let col of tableColumns(); trackBy: trackByColKey">{{ col.label || col.key }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of tableRows()">
            <td *ngFor="let col of tableColumns(); trackBy: trackByColKey">
              <input class="ss-widget-cell-input" [type]="col.type === 'number' ? 'number' : 'text'" [value]="row[col.key] || ''" />
            </td>
          </tr>
          <tr *ngIf="!tableRows().length">
            <td *ngFor="let col of tableColumns(); trackBy: trackByColKey">
              <input class="ss-widget-cell-input" [type]="col.type === 'number' ? 'number' : 'text'" placeholder="—" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngSwitchDefault class="ss-widget-empty">Unsupported widget.</div>
</div>
